import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { POST_SELECTED_WHEN } from "../../store/action";
import { t } from "../../translations";
import { dayPlusOne } from "../functions/dateFunctions";
import "../styles/layout.css";

// image importation

import { configureCrisp } from "../../utils/crispConfig";

import Lottie from "react-lottie";

import success from "../../assets/success.json";

const LayoutSuccessGlocery = () => {
  const history = useHistory();

  let selectedLang = useSelector((state) => state.lang);
  let selectedZip = useSelector((state) => state.selectedZip);

  const dispatch = useDispatch();

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, []);

  const initialData = async () => {
    const tday = dayPlusOne();
    WhenDate(tday);
    if (selectedZip === null) {
      return history.push("/");
    }
  };

  const WhenDate = (value) => dispatch(post_selected_when(value));

  return (
    <div className="global-block">
      <div className="full-block">
        <div
          className="contant_box_404"
          style={{
            width: "100vw",
            height: "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: success,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
              }
            }}
            height={250}
            width={400}
            isStopped={false}
            isPaused={false}
            style={{ marginTop: 30 }}
          />
          <h3 className="h2">{t("order_success.title", selectedLang)}</h3>

          <p>{t("order_success.message", selectedLang)}</p>
          <a
            onClick={() => {
              return history.push("/chef/iam-a-chef/glocery");
            }}
            className="link_404"
          >
            {t("order_success.check_orders_button", selectedLang)}
          </a>
        </div>
        <div
          style={{
            height: 40
          }}
        ></div>
      </div>
    </div>
  );
};

export default LayoutSuccessGlocery;

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});


